import React from 'react';
import '../index.css';
import EntitlementEditor from './EntitlementEditor';
import { RepositoryProvider } from '../contexts/RepositoryContext';
import { MockRepository } from '../repositories/dummyData';
import { EntitlementObject, ContextMenuItem } from '../types';
import type { EditorAiCapability } from '../hooks/useAiCapability';

interface EntitlementEditorWrapperProps {
  initialData: EntitlementObject;
  onSave?: (data: EntitlementObject) => void;
  onSaveAndReturn?: (data: EntitlementObject) => void;
  onBack?: () => void;
  onLoadRequest?: () => void;
  additionalCanvasMenuItems?: ContextMenuItem[];
  additionalNodeMenuItems?: (node: any) => ContextMenuItem[];
  onAiCapabilityReady?: (cap: EditorAiCapability | null) => void;
}

/**
 * EntitlementEditorWrapper - A wrapper component for the EntitlementEditor.
 *
 * IMPORTANT: The host application MUST wrap this component in a ReactFlowProvider.
 *
 * @example
 * ```tsx
 * import { ReactFlowProvider } from 'reactflow';
 * import { EntitlementEditorWrapper } from 'entitlement-graph-editor';
 *
 * function App() {
 *   return (
 *     <ReactFlowProvider>
 *       <EntitlementEditorWrapper {...props} />
 *     </ReactFlowProvider>
 *   );
 * }
 * ```
 */
const EntitlementEditorWrapper: React.FC<EntitlementEditorWrapperProps> = ({
  initialData,
  onSave,
  onSaveAndReturn,
  onBack,
  onLoadRequest,
  additionalCanvasMenuItems,
  additionalNodeMenuItems,
  onAiCapabilityReady
}) => {
  return (
    <EntitlementEditor
      key={initialData.name}
      initialData={initialData}
      onSave={onSave}
      onSaveAndReturn={onSaveAndReturn}
      onBack={onBack}
      additionalCanvasMenuItems={additionalCanvasMenuItems}
      additionalNodeMenuItems={additionalNodeMenuItems}
      onAiCapabilityReady={onAiCapabilityReady}
    />
  );
};

export default EntitlementEditorWrapper;
export { MockRepository };